import { createNativeStackNavigator } from '@react-navigation/native-stack';
import OnboardingScreen from '../screens/OnboardingScreen';
import LoginScreen from '../screens/LoginScreen';
import SignupScreen from '../screens/SignupScreen';
import ForgotPasswordScreen from '../screens/ForgotPasswordScreen';
import CreatePasswordScreen from '../screens/CreatePasswordScreen';
import CheckEmailScreen from '../screens/CheckEmailScreen';
import PreferencesGenreScreen from '../screens/PreferencesGenreScreen';
import PreferencesAuthorsScreen from '../screens/PreferencesAuthorsScreen';
import HomeScreen from '../screens/HomeScreen';
import GetSuggestionsScreen from '../screens/GetSuggestionsScreen';
import AuthorDetailsScreen from '../screens/AuthorDetailsScreen';
import BookOverviewScreen from '../screens/BookOverviewScreen';
import BookInformationScreen from '../screens/BookInformationScreen';
import BookReviewsScreen from '../screens/BookReviewsScreen';
import PlayerScreen from '../screens/PlayerScreen';
import DownloadsScreen from '../screens/DownloadsScreen';
import PeopleListScreen from '../screens/PeopleListScreen';
import LibraryScreen from '../screens/LibraryScreen';
import SettingsScreen from '../screens/SettingsScreen';
import CreateChildProfileScreen from '../screens/CreateChildProfileScreen';
import ProfileSelectScreen from '../screens/ProfileSelectScreen';

export type RootStackParamList = {
  Onboarding: undefined;
  Login: undefined;
  Signup: undefined;
  CreateChildProfile: undefined;
  ProfileSelect: undefined;
  ForgotPassword: undefined;
  CreatePassword: undefined;
  CheckEmail: undefined;
  PreferencesGenre: undefined;
  PreferencesAuthors: { topicIds?: number[] } | undefined;
  Home: undefined;
  GetSuggestions: undefined;
  AuthorDetails: { id?: number } | undefined;
  BookOverview: { id?: number; slug?: string } | undefined;
  BookInformation: { id?: number; slug?: string } | undefined;
  BookReviews: { id?: number; slug?: string } | undefined;
  Player: { id?: number; slug?: string } | undefined;
  Downloads: { title?: string; topic_id?: number; category_id?: number; person_id?: number; libraryType?: 'favorites' | 'viewed' | 'listening' } | undefined;
  PeopleList: { title?: string } | undefined;
  Library: undefined;
  Settings: undefined;
};

const Stack = createNativeStackNavigator<RootStackParamList>();

export default function RootNavigator() {
  return (
    <Stack.Navigator initialRouteName="Home" screenOptions={{ headerShown: false }}>
      <Stack.Screen name="Onboarding" component={OnboardingScreen} />
      <Stack.Screen name="Login" component={LoginScreen} />
      <Stack.Screen name="Signup" component={SignupScreen} />
      <Stack.Screen name="CreateChildProfile" component={CreateChildProfileScreen} />
      <Stack.Screen name="ProfileSelect" component={ProfileSelectScreen} />
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} />
      <Stack.Screen name="CreatePassword" component={CreatePasswordScreen} />
      <Stack.Screen name="CheckEmail" component={CheckEmailScreen} />
      <Stack.Screen name="PreferencesGenre" component={PreferencesGenreScreen} />
      <Stack.Screen name="PreferencesAuthors" component={PreferencesAuthorsScreen} />
      <Stack.Screen name="Home" component={HomeScreen} />
      <Stack.Screen name="GetSuggestions" component={GetSuggestionsScreen} />
      <Stack.Screen name="AuthorDetails" component={AuthorDetailsScreen} />
      <Stack.Screen name="BookOverview" component={BookOverviewScreen} />
      <Stack.Screen name="BookInformation" component={BookInformationScreen} />
      <Stack.Screen name="BookReviews" component={BookReviewsScreen} />
      <Stack.Screen name="Player" component={PlayerScreen} />
      <Stack.Screen name="Downloads" component={DownloadsScreen} />
      <Stack.Screen name="PeopleList" component={PeopleListScreen} />
      <Stack.Screen name="Library" component={LibraryScreen} />
      <Stack.Screen name="Settings" component={SettingsScreen} />
    </Stack.Navigator>
  );
}
